import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=76aa0abd&"
import script from "./CompanyCard.js?vue&type=script&lang=js&"
export * from "./CompanyCard.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports